import { data } from "jquery";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PopoverController } from "@ionic/angular";
import { ModalLoadFilesComponent } from "../../modal-load-files/modal-load-files.component";

@Component({
  selector: "app-create-actividad-opcion-multiple",
  templateUrl: "./create-actividad-opcion-multiple.component.html",
  styleUrls: ["./create-actividad-opcion-multiple.component.scss"],
})
export class CreateActividadOpcionMultipleComponent implements OnInit {
  @Output() DataOpcionMultiple = new EventEmitter<any>(); // Usamos EventEmitter
  @Input() dataOpcionMultiple: any = null; // Datos entrantes para editar
  ionicForm: FormGroup;
  count: number = 0;
  constructor(
    private formBuilder: FormBuilder,
    private popoverCtrl: PopoverController
  ) {
    this.createForm();
    // Escuchar cambios en el formulario y emitir datos
    this.ionicForm.valueChanges.subscribe((val) => {
      this.DataOpcionMultiple.emit({
        data: this.ionicForm.value,
        valid: this.ionicForm.valid,
      });
    });
  }

  ngOnInit() {
    if (this.dataOpcionMultiple) {
      this.ionicForm.patchValue(this.dataOpcionMultiple);
      // Limpiar el FormArray antes de agregar las opciones
      this.getOpcionesArray.clear();
      // Agregar las opciones del data entrante
      if (
        this.dataOpcionMultiple.opciones &&
        Array.isArray(this.dataOpcionMultiple.opciones)
      ) {
        this.dataOpcionMultiple.opciones.forEach((opcion: any) => {
          const opcionGroup = this.createOpcionFormGroup(opcion.id);
          opcionGroup.patchValue(opcion);
          this.getOpcionesArray.push(opcionGroup);
        });
      }
    }
  }

  createForm() {
    this.ionicForm = this.formBuilder.group({
      opcionExplicacion: [""], // El texto de la explicación
      opcionPregunta: ["", [Validators.required]], // El texto de la pregunta
      activeOption: ["", [Validators.required]], // El radio seleccionado
      file: [null], // Archivo subido
      url: [null], // URL de la imagen o video
      type: [0], // Tipo de actividad (2 para opción múltiple)
      opciones: this.formBuilder.array([]), // Array de opciones
    });
  }
  // Crear un FormGroup para cada opción
  createOpcionFormGroup(id?: string): FormGroup {
    const opcionId = id || this.generateId();
    return this.formBuilder.group({
      id: [opcionId],
      respuesta: ["", [Validators.required]], // El texto del input
      selected: [false], // Si está seleccionado o no
      file: [null], // Archivo subido
      type: [0], // Tipo de opción (1 para texto, 2 para imagen, 3 para video)
      url: [null], // URL de la imagen o video
    });
  }

  // Agregar nueva opción
  addOpcion(): void {
    const opcionGroup = this.createOpcionFormGroup();
    this.getOpcionesArray.push(opcionGroup);
  }
  // Eliminar opción
  deleteOpcion(index: number): void {
    const opcionId = this.getOpcionesArray.at(index).get("id")?.value;
    // Eliminar del FormArray
    this.getOpcionesArray.removeAt(index);

    // Si la opción eliminada era la activa, limpiar la selección
    if (this.ionicForm.get("activeOption")?.value === opcionId) {
      this.ionicForm.get("activeOption")?.setValue("");
    }
  }
  private generateId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  get getOpcionesArray(): FormArray {
    return this.ionicForm.get("opciones") as FormArray;
  }

  async openRadioPopover(ev: Event, opcionId: string) {
    const popover = await this.popoverCtrl.create({
      component: ModalLoadFilesComponent,
      event: ev,
      translucent: true,
      showBackdrop: true,
      cssClass: "custom-files-popover",
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      const opcionControl = this.getOpcionesArray.controls.find(
        (control) => control.get("id")?.value === opcionId
      );
      if (opcionControl) {
        opcionControl.get("file")?.setValue(data.file);
        opcionControl.get("url")?.setValue(data.url);
        opcionControl.get("type")?.setValue(data.type);
      }
    }
  }

  async addFileOpPregunta(ev: Event) {
    const popover = await this.popoverCtrl.create({
      component: ModalLoadFilesComponent,
      event: ev,
      translucent: true,
      showBackdrop: true,
      cssClass: "custom-files-popover",
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      this.ionicForm.get("file")?.setValue(data.file);
      this.ionicForm.get("url")?.setValue(data.url);
      this.ionicForm.get("type")?.setValue(data.type);
    }
  }

  removeFilePregunta() {
    this.ionicForm.get("file")?.setValue(null);
    this.ionicForm.get("url")?.setValue(null);
    this.ionicForm.get("type")?.setValue(0);
    this.ionicForm.updateValueAndValidity();
  }
  removeFileOpcion(id: any) {
    const opcionControl = this.getOpcionesArray.controls.find(
      (control) => control.get("id")?.value === id
    );
    if (opcionControl) {
      opcionControl.get("file")?.setValue(null);
      opcionControl.get("url")?.setValue(null);
      opcionControl.get("type")?.setValue(0);
    }
    this.ionicForm.updateValueAndValidity();
  }
  get IonicFormControls() {
    return this.ionicForm.controls;
  }

  selectOpcion(id: string) {
    this.getOpcionesArray.controls.forEach((control) => {
      const isSelected = control.get("id")?.value === id;
      control.get("selected")?.setValue(isSelected);
    });

    this.ionicForm.updateValueAndValidity();
  }

  openUrl(url: string) {
    window.open(url, "_blank");
  }
}
